/**
 * Role tier helper — mirrors the Worker's src/lib/authz.ts tier order so the
 * SPA's nav/route gating matches server-side enforcement. The SPA gate is
 * advisory UX; admin-api enforces the real boundary.
 */
import type { Role } from '@/types';

// Higher number = more privilege.
const TIER: Record<Role, number> = {
  read_only: 0,
  support: 1,
  admin: 2,
  super_admin: 3,
};

/** True if `role` is `required` or above (super_admin > admin > support > read_only). */
export function roleAtLeast(role: Role | null, required: Role): boolean {
  if (role === null) return false;
  return TIER[role] >= TIER[required];
}

export const ROLE_LABEL: Record<Role, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  support: 'Support',
  read_only: 'Read-only',
};
